/** @deprecated This is for Legacy QuoteLog form. For SRF Use ServiceRequestDropdownsDto.cs::LinesOfBusiness*/
export class LineOfBusinessDto {
  value: string;
  label: string;
}
